import { render, staticRenderFns } from "./news5.vue?vue&type=template&id=dea4e4be&scoped=true"
import script from "./news5.vue?vue&type=script&lang=js"
export * from "./news5.vue?vue&type=script&lang=js"
import style0 from "./news5.vue?vue&type=style&index=0&id=dea4e4be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea4e4be",
  null
  
)

export default component.exports